const containersType = [
  { key: '20FT', text: '20FT' },
  { key: '21FT', text: '21FT' },
  { key: '40FT', text: '40FT' },
  { key: '40FT HC', text: '40FT HC' },
  { key: '41FT', text: '41FT' },
];

export default containersType;
